import getQueryParams from '@/common/helpers/getQueryParams';

const useQueryParams = getQueryParams;

export default useQueryParams;
